import { Field, Model } from 'serialize-ts';
import { ProductIndexOfferService } from '~app/modules/product/models/product-index-offer-service.model';

@Model()
export class OfferService {
  @Field()
  name: string;

  public static mapOfferServices(offerServices: ProductIndexOfferService[]): OfferService[] {
    return offerServices.map(
      (productIndexOfferService: ProductIndexOfferService): OfferService => ({
        name: productIndexOfferService?.name
      })
    );
  }
}
